import { ManagePerpetualsComponent } from './manage-perpetuals.component';
import { ManagePerpetualsProgramtypesComponent } from './manage-perpetuals-programtypes/manage-perpetuals-programtypes.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'managePerpetuals',
    component: ManagePerpetualsComponent,
    children: [
      {
        path: 'managePerpetualsProgramtypes/:programtype',
        component: ManagePerpetualsProgramtypesComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagePerpetualsRoutingModule { }
